export const LIVE_AI_TOOL_ACTIVITY_EVENT = "cmcp:live-ai-tool-activity";
export const LIVE_AI_DRIVING_EVENT = "cmcp:live-ai-driving";
export const LIVE_AI_CONNECTION_EVENT = "cmcp:live-ai-connection";
export const LIVE_AI_DRIVE_PAUSE_EVENT = "cmcp:live-ai-drive-pause";
export const LIVE_AI_AGENT_SESSION_EVENT = "cmcp:live-ai-agent-session";
export const LIVE_AI_AGENT_ACTIVITY_EVENT = "cmcp:live-ai-agent-activity";

export const BROWSER_DRIVE_PAUSED_KEY = "cmcp:browser-drive-paused";
export const AGENT_FOLLOW_MODE_KEY = "cmcp:agent-follow-mode";

export interface LiveToolActivity {
  activity_id: string;
  tool_name: string;
  phase: "started" | "succeeded" | "failed";
  mediator: "claude" | "chatgpt" | "cursor" | "other_mcp" | "web_ui" | "api_direct";
  workspace_id?: string;
  started_at: string;
  completed_at?: string;
  duration_ms?: number;
  error_code?: string;
}

export type LiveDrivingState =
  | { state: "active"; mediator: string; ttl_seconds?: number }
  | { state: "other_tab"; mediator: string }
  | { state: "released"; mediator?: string };

// ── Live Operations (agent activity stream) ───────────────────────────────
// SSE payloads emitted by broadcastAgentSession / broadcastAgentActivity.
// They mirror the durable agent_sessions / agent_activity_events rows and
// are reduced into the shared store in agent-activity-store.ts.

export interface LiveAgentSession {
  session_id: string;
  workspace_id?: string | null;
  status?: string;
  title?: string;
  current_step?: string;
  progress_current?: number;
  progress_total?: number;
  safe_summary?: string;
  error_code?: string;
  source: string;
  mediator: string;
  heartbeat_at: string;
  completed_at?: string;
}

export interface LiveAgentActivity {
  event_id: string;
  session_id: string;
  session_seq: number;
  workspace_id?: string | null;
  kind: string;
  phase: string;
  source: string;
  mediator: string;
  tool_name?: string;
  activity_id?: string;
  title: string;
  summary?: string;
  entity_type?: string;
  entity_id?: string;
  entity_label?: string;
  artifact_type?: string;
  artifact_id?: string;
  artifact_url?: string;
  progress_current?: number;
  progress_total?: number;
  duration_ms?: number;
  error_code?: string;
  emitted_at: string;
}

export function isBrowserDrivePaused(): boolean {
  try { return localStorage.getItem(BROWSER_DRIVE_PAUSED_KEY) === "1"; }
  catch { return false; }
}

export function setBrowserDrivePaused(paused: boolean): void {
  try { localStorage.setItem(BROWSER_DRIVE_PAUSED_KEY, paused ? "1" : "0"); } catch {}
  window.dispatchEvent(new CustomEvent(LIVE_AI_DRIVE_PAUSE_EVENT, { detail: { paused } }));
}

/**
 * Follow mode: when on, artifact_published / entity_focus activity events
 * may navigate the driving window. Off = ambient watch (badges + pulses
 * only). Independent of browser-drive pause, which governs the AI's
 * explicit choreography tools.
 */
export function isAgentFollowMode(): boolean {
  try { return localStorage.getItem(AGENT_FOLLOW_MODE_KEY) === "1"; }
  catch { return false; }
}

export function setAgentFollowMode(on: boolean): void {
  try { localStorage.setItem(AGENT_FOLLOW_MODE_KEY, on ? "1" : "0"); } catch {}
  window.dispatchEvent(new CustomEvent("cmcp:agent-follow-mode", { detail: { on } }));
}
